import type { Schema } from '@/api/client'
import { CHANGES } from './changes'

export type SiteGating = Schema<'GatingOut'>

/** One line for a read-only row: `2 of 4 changes automatic · admin decides · reminder after 7 days`. */
export function summariseGating(site: SiteGating): string {
  const on = CHANGES.filter((change) => site.automatic[change.code] === true).length
  const what =
    on === 0
      ? 'Everything needs approval'
      : `${String(on)} of ${String(CHANGES.length)} changes automatic`
  const who = site.approver_role === 'owner' ? 'owner decides' : 'owner or admin decides'
  const when =
    site.stale_after_days === 0
      ? 'never reminds'
      : `reminder after ${String(site.stale_after_days)} days`
  return `${what} · ${who} · ${when}`
}
